import {IProfile} from "StateInterface";
import {ILatestStatus} from "profile/interface";

export enum Actions {
    SET_PROFILE_INFO = "SET_PROFILE_INFO",
    SET_PAANDU_PROFILE = "SET_PAANDU_PROFILE",
    CLEAR_PROFILE_INFO = "CLEAR_PROFILE_INFO",
    SET_LAM_PROFILE = "SET_LAM_PROFILE",
    SET_LATEST_APPLICATION_STATUS = "SET_LATEST_APPLICATION_STATUS",
}

export function setProfileInfo(profile) {
    return {type: Actions.SET_PROFILE_INFO, body: profile};
}

export function setPaanduProfile(profile: IProfile) {
    return {type: Actions.SET_PAANDU_PROFILE, body: profile};
}

export const clearProfile = () => {
    return {type: Actions.CLEAR_PROFILE_INFO};
};

export function setLamProfile(profile: IProfile) {
    return {type: Actions.SET_LAM_PROFILE, body: profile};
}

export function setLatestApplicationStatus(status: ILatestStatus) {
    return {type: Actions.SET_LATEST_APPLICATION_STATUS, body: status};
}
